import React, { ReactNode, useMemo } from 'react';

import { UiComponent } from 'components';
import { tableWrap, tableToolbar } from 'styles/table';
import { IEvent, IPageOption } from 'types';
import { useNavigate } from 'react-router-dom';
import { BsPlusLg } from 'react-icons/bs';
import dayjs from 'dayjs';
import { getEventStatus } from '../utils';
import { BiPencil } from 'react-icons/bi';

const COLS: string[] = [
  'ID',
  '봉사명',
  // '단체명',
  '모집상태',
  '모집기간',
  '봉사일시',
  '생성일',
];

interface Props {
  pageOption: IPageOption;
  handlePage: (option: IPageOption) => void;
  data: IEvent[];
  totalPage: number;
  toolbar?: ReactNode;
}

function List({ data, toolbar, ...pageOptions }: Props) {
  const navigate = useNavigate();

  const renderer: Record<
    (typeof COLS)[number],
    (data: IEvent & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      ID: ({ id }: IEvent) => <>{id}</>,
      봉사명: ({ id, title }: IEvent) => (
        <p
          css={{
            textAlign: 'left',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          title="봉사 메타 정보 수정"
          onClick={() => navigate(`/event/${id}`)}
        >
          {title}
          <span css={{ marginLeft: '4px' }}>
            <BiPencil size={11} />
          </span>
        </p>
      ),
      // 단체명: ({ organizationName }: IEvent) => <>{organizationName}</>,
      모집상태: ({
        eventStatus,
        startDate,
        endDate,
        enrollStartDate,
        enrollEndDate,
      }: IEvent) => (
        <>
          {getEventStatus(
            eventStatus,
            startDate,
            endDate,
            enrollStartDate,
            enrollEndDate,
          )}
        </>
      ),
      모집기간: ({ enrollStartDate, enrollEndDate }: IEvent) => (
        <>{`${dayjs(enrollStartDate).format('YYYY-MM-DD HH:mm')} - ${dayjs(enrollEndDate).format('YYYY-MM-DD HH:mm')}`}</>
      ),
      봉사일시: ({ startDate, endDate }: IEvent) => (
        <>{`${dayjs(startDate).format('YYYY-MM-DD HH:mm')} - ${dayjs(endDate).format('YYYY-MM-DD HH:mm')}`}</>
      ),
      생성일: ({ createdAt }: IEvent) => (
        <>{dayjs(createdAt).format('YYYY-MM-DD HH:mm')}</>
      ),
    }),
    [],
  );

  return (
    <>
      <UiComponent.Box>
        <div css={tableToolbar}>
          {toolbar ?? <div />}
          <div>
            <UiComponent.Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/event/register')}
              css={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '0 4px',
              }}
            >
              <BsPlusLg size={18} />
              <p css={{ fontSize: '14px' }}>행사 추가</p>
            </UiComponent.Button>
            {/* <FormComponent.Select
              options={[
                { name: '가입일', value: '1' },
                { name: '최종접속일', value: '2' },
              ]}
            />
            <FormComponent.Select
              css={{ width: '90px' }}
              options={[
                { name: '20', value: '20' },
                { name: '50', value: '50' },
                { name: '100', value: '100' },
              ]}
            /> */}
          </div>
        </div>
        <div css={tableWrap}>
          <UiComponent.Table
            cols={COLS}
            renderer={renderer}
            data={data}
            sticky
          />
        </div>
        <UiComponent.Pagination {...pageOptions} />
      </UiComponent.Box>
    </>
  );
}

export default List;
